import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';
import ServicesProcess from './components/ServicesProcess';

export default function ServicesPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <ServicesHero />
        <ServicesDetail />
        <ServicesProcess />
        {/* CTA */}
        <section className="py-20 bg-navy-900 text-center">
          <div className="max-w-2xl mx-auto px-6">
            <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white mb-4">
              Ready to Experience All-Inclusive Living?
            </h2>
            <p className="text-white/65 text-base mb-8 leading-relaxed">
              Browse our available furnished rooms and move in with everything already set up — zero stress, zero hidden costs.
            </p>
            <a
              href="https://rentals.galaxyhousing.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-sm px-8 py-4 rounded transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-heart-line" />
              </div>
              View Available Rentals
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
